import { withSuspense } from '@/ui/utils/withSuspense'

import { PointsSkeleton } from './components/skeleton/PointsSkeleton'
import { GuestView } from '@/ui/organisms/guest-view/GuestView'
import { useAccount } from '@/domain/hooks/useAccount'
import { usePrivy } from '@privy-io/react-auth'
import { SeasonMewPointsView } from './views/SeasonMewPointsView'

function SeasonMewContainer() {
  const account = useAccount()
  const { connectWallet } = usePrivy()

  if (!account) {
    return <GuestView openConnectModal={connectWallet} />
  }

  return <SeasonMewPointsView />
}

const SeasonMewContainerWithSuspense = withSuspense(SeasonMewContainer, PointsSkeleton)
export { SeasonMewContainerWithSuspense as SeasonMewContainer }
